import {
  Box,
  Card,
  CardHeader,
  Tabs,
  Tab,
  CardContent,
  CardActions,
  Button,
  Divider,
  TextField,
  Typography
} from '@mui/material';
import React from 'react';
import { TimeSpans } from './Timespans';
import { EventTypes } from './EventTypes';
import { Locations } from './MapAreas'
import styles from './Profiles.module.css';
import { debounce } from "lodash"


const ProfileName = (props) => {
  const value = props.selectedProfile.name;
  const handleChange = props.handleChange;
  return (
    <TextField
      fullWidth
      label="Profile Name"
      name="name"
      onChange={handleChange}
      required
      variant="outlined"
      defaultValue={value}
    />
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export const NotificationProfileDetails = (props) => {
  const [value, setValue] = React.useState(0);
  const selectedProfile = props.selectedProfile;
  const setSelectedProfile = props.setSelectedProfile;
  const editedProfile = props.editedProfile;
  const resetProfile = props.resetProfile;
  const saveUser = props.saveUser;
  const loading = props.loading;

  const handleTabChange = (e, newValue) => {
    setValue(newValue);
  };

  const handleTextChange = debounce((event) => {
    console.log("handleTextChange");
    setSelectedProfile(selectedProfile => { return {
      ...selectedProfile,
      [event.target.name]: event.target.value
    }})
  }, 500);

  return (
    <Box>
      <Card>
        <CardHeader title={selectedProfile.isNew ? "Create New Profile" : selectedProfile.name} sx={{ paddingBottom: 2 }} />
        <CardContent sx={{ margin: 0, paddingTop: 0 }}>
          {selectedProfile.isNew ? <ProfileName selectedProfile={selectedProfile} handleChange={handleTextChange} /> : null}
          <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 0, paddingBottom: 0 }}>
            <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example">
              <Tab label="Days and Times" />
              <Tab label="Event Types" />
              <Tab label="Locations" />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <TimeSpans selectedProfile={selectedProfile} setSelectedProfile={setSelectedProfile} loading={loading}/>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <EventTypes selectedProfile={selectedProfile} setSelectedProfile={setSelectedProfile} />
          </TabPanel>
          <TabPanel value={value} index={2} className={styles.profileMap}>
            <Locations selectedProfile={selectedProfile} setSelectedProfile={setSelectedProfile} />
          </TabPanel>
        </CardContent>
        <Divider />
        <CardActions sx={{ m: 1 }}>
          <Button color="primary"
            variant="contained" disabled={!editedProfile || loading} onClick={() => { saveUser(selectedProfile) }}>Save</Button>
          <Button color="secondary"
            variant="contained" disabled={!editedProfile || loading} onClick={resetProfile}>Reset</Button>
        </CardActions>
      </Card>
    </Box>
  )
}